/**
 * Merge orientation-grade riverLine + sections (+ optional facts) onto a highlight.
 * Pack wins when the highlight is missing geometry; existing JSON geometry is kept.
 */
function applyRaftingRiverPack(highlight, pack) {
  if (!highlight || !pack) return highlight;
  const entry = pack[highlight.slug];
  if (!entry) return highlight;

  const next = { ...highlight };
  if (
    (!next.riverLine || !next.riverLine.length) &&
    entry.riverLine &&
    entry.riverLine.length
  ) {
    next.riverLine = entry.riverLine;
  }
  if (
    (!next.sections || !next.sections.length) &&
    entry.sections &&
    entry.sections.length
  ) {
    next.sections = entry.sections;
  }
  if (entry.facts && entry.facts.length) {
    const have = new Set((next.facts || []).map((f) => String(f.key || "").toLowerCase()));
    const extras = entry.facts.filter(
      (f) => !have.has(String(f.key || "").toLowerCase())
    );
    if (extras.length) next.facts = [...(next.facts || []), ...extras];
  }
  return next;
}

module.exports = { applyRaftingRiverPack };
